import React, { Component } from "react";
import ReactQuill from "react-quill";
import Quill from "quill";
import "react-quill/dist/quill.snow.css";
import {
  Switch,
  Icon,
  Button,
  TextArea,
  InputGroup,
  Callout,
  Slider,
} from "@blueprintjs/core";
import { validate } from "validate.js";
import { Translate, I18n } from "react-redux-i18n";
import LoadingIndicator from "../LoadingIndicator";
import CurrencySelect from "../CurrencySelector";
import FileInput from "../FileInput";
import GoogleLocation from "../GoogleLocation";
import GetUserLocation from "../GetUserLocation";
import CircleImage from "../Image/CircleImage";
import AgreementModal from "../AgreementModal/AgreementModal";
import { getCircleDefaultImage } from "../../utils/utils.js";
import MaxActiveBookings from "../MaxActiveBookings";
import MaxBookingDuration from "../MaxBookingDuration";
import CircleStatusSelector from "../CircleStatus/CircleStatusSelector";

class CircleForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      quillModules: {
        toolbar: {
          container: [
            [{ header: [1, 2, 3, false] }],
            ["bold", "italic", "underline", "strike", "blockquote"],
            [{ list: "ordered" }, { list: "bullet" }, { indent: "-1" }, { indent: "+1" }],
            ["link", "image"],
            ["clean"],
          ],
          handlers: {
            image: function () {
              var range = this.quill.getSelection();
              var value = prompt("Please copy paste the image url here.");
              if (value) {
                this.quill.insertEmbed(range.index, "image", value, Quill.sources.USER);
              }
            },
          },
        },
      },

      quillFormats: [
        "header",
        "bold",
        "italic",
        "underline",
        "strike",
        "blockquote",
        "list",
        "bullet",
        "indent",
        "link",
        "image",
      ],
      circle_form: {
        status: "",
        name: "",
        currency: "SEK",
        max_owners_no: 2,
        url: "",
        price: "",
        instructions: "",
        description: "",
        base64_image: "",
        pre_owned: false,
        has_agreement: true,
        address: "",
        lat: "",
        lon: "",
        country: "",
        city: "",
        is_public: true,
        is_prylpoolen: false,
        max_active_bookings_per_member: -1,
        max_booking_duration_in_minutes: -1,
        door_id: "",
        door_indications_heading: "",
        door_indications_paragraph_1: "",
        door_indications: "",
        door_indications_paragraph_2: "",
        door_indications_image_url: "",
        rentable: false,
        rental_pricing_tier: "",
      },
      validation_errors: {},
      product_image: undefined,
      show_location_modal: false,
      location: {
        lat: "",
        lon: "",
      },
      show_location_loader: false,
      show_agreement: false,
    };
  }

  toggleAgreement = (e) => {
    e.preventDefault();
    this.setState((state) => ({ show_agreement: !state.show_agreement }));
  };

  componentDidMount() {
    if (this.props.edit_circle) {
      let loaded_form = {};
      Object.keys(this.state.circle_form).forEach((key) => {
        loaded_form[key] = this.props.edit_circle.hasOwnProperty(key)
          ? this.props.edit_circle[key]
          : this.state.circle_form[key];
      });
      this.setState((state) => ({ circle_form: loaded_form, product_image: this.props.edit_circle.product_image }));
    } else {
      getCircleDefaultImage((image, base64_image) => {
        //if user doesn't select any image, a default one will be attached
        this.setState({
          circle_form: {
            ...this.state.circle_form,
            base64_image: base64_image,
          },
        });
      });
    }

    if (this.props.reference) {
      if (this.props.reference === "whitemonday") {
        this.setState((state) => {
          return { circle_form: { ...state.circle_form, pre_owned: true, has_agreement: false } };
        });
      }
    }
  }
  updateInstructions = (instructions) => {
    let circle_form = {
      ...this.state.circle_form,
      instructions: instructions,
    };
    this.setState({ circle_form });
  };
  updateFields = (event) => {
    if (event.target.id === "base64_image") {
      const validationErrors = validate({ base64_image: event.target.value }, this.props.validators);
      if (validationErrors) {
        this.setState({ validation_errors: validationErrors });
        this.setState({ product_image: null });
        return false;
      }
    }

    let circle_form = {
      ...this.state.circle_form,
      [event.target.id]: event.target.value,
    };

    if (event.target.id === "is_prylpoolen") {
      const max_owners_no = this.getMaxOwnersNo(event.target.value);
      circle_form = { ...circle_form, max_owners_no };
    }

    this.setState({ circle_form });

    return true;
  };

  getMaxOwnersNo = (is_prylpoolen) => {
    if (is_prylpoolen) {
      return 100;
    } else {
      let max_member = 0;
      if (this.props.edit_circle) {
        max_member = this.props.edit_circle.max_owners_no;
      }

      max_member = max_member <= 10 ? max_member : 10;

      return max_member;
    }
  };

  submitForm = (e) => {
    e.preventDefault();

    const validationErrors = validate(this.state.circle_form, this.props.validators);

    if (this.props.edit_circle && validationErrors && validationErrors["base64_image"]) {
      delete validationErrors["base64_image"];
    }

    if (validationErrors && Object.keys(validationErrors).length) {
      window.scrollTo(0, 0);
    }

    this.setState({
      validation_errors: validationErrors ? validationErrors : {},
    });

    if (!validationErrors || Object.keys(validationErrors).length === 0) {
      this.props.onSave(this.state.circle_form);
    }
  };

  productImageChanged = (image, base64_image) => {
    const updateStatus = this.updateFields({ target: { id: "base64_image", value: base64_image } });
    if (updateStatus) {
      this.setState({ product_image: image });
    }
  };

  selectedLocation = (location) => {
    this.setState({
      show_location_modal: false,
      circle_form: {
        ...this.state.circle_form,
        address: location.address,
        city: location.city,
        country: location.country,
        lat: String(location.lat),
        lon: String(location.lng),
      },
    });
  };

  showLocationModal = () => {
    if (this.state.circle_form.lat && this.state.circle_form.lon) {
      this.setState({
        show_location_modal: true,
        location: { lat: this.state.circle_form.lat, lon: this.state.circle_form.lon },
      });
    } else if (
      this.props.user_details &&
      "lat" in this.props.user_details.location &&
      this.props.user_details.location.lat
    ) {
      this.setState({
        show_location_modal: true,
        location: { lat: this.props.user_details.location.lat, lon: this.props.user_details.location.lon },
      });
    } else {
      this.setState({ show_location_loader: true });
      GetUserLocation(
        (position) => {
          this.setState({
            show_location_modal: true,
            show_location_loader: false,
            location: { lat: position.coords.latitude, lon: position.coords.longitude },
          });
        },
        (error) => {
          this.setState({ show_location_modal: true, show_location_loader: false });
        }
      );
    }
  };

  render() {
    return (
      <>
        <GoogleLocation
          location={{ lat: this.state.location.lat, lng: this.state.location.lon }}
          showModal={this.state.show_location_modal}
          onClose={() => {
            this.setState({ show_location_modal: false });
          }}
          onSave={this.selectedLocation}
        />
        <form className="onboarding-form" onSubmit={this.submitForm}>
          <h1 className="bp3-heading">
            <Translate value="circle_form.create_circle" />
          </h1>

          <div className="form-split">
            <div className="split-item">
              <div className={this.state.validation_errors.base64_image ? "form-group error" : "form-group"}>
                <FileInput onImageSelected={this.productImageChanged}>
                  <div className="photo-upload product">
                    {!this.state.product_image && (
                      <label htmlFor="product-image">
                        {this.state.validation_errors.base64_image ? (
                          <Translate value={this.state.validation_errors.base64_image[0]} />
                        ) : (
                          <>
                            <Icon icon="media" iconSize="48" className="icon" />
                            <div>
                              <Translate value="new_circle.labels.add_product_image" />
                            </div>
                          </>
                        )}
                      </label>
                    )}
                    {this.state.product_image && (
                      <CircleImage src={this.state.product_image} size="medium" alt="no image" />
                    )}
                  </div>
                </FileInput>
                {/* <InputGroup
                                    type="url"
                                    id="image_url"
                                    value={this.state.circle_form.product_image_url}
                                    placeholder={I18n.t("new_circle.placeholders.paste_image_url")}
                                    fill={true}
                                    className="no-icon image-paste"
                                    onChange={this.imageUrlChanged}
                                /> */}
              </div>
            </div>
            <div className="split-item">
              {this.props.edit_circle && this.props.is_super_user && (
                <div className="form-group">
                  <label htmlFor="price">
                    <Translate value="new_circle.labels.circle_status" />
                  </label>
                  <CircleStatusSelector
                    status={this.state.circle_form.status ? this.state.circle_form.status : "member_gathering"}
                    statusChanged={(status) => {
                      this.updateFields({
                        target: { id: "status", value: status },
                      });
                    }}
                  />
                </div>
              )}

              <div className={this.state.validation_errors.name ? "form-group error" : "form-group"}>
                <label htmlFor="name">
                  {this.state.validation_errors.name ? (
                    <Translate value={this.state.validation_errors.name[0]} />
                  ) : (
                    <Translate value="new_circle.labels.product_name" />
                  )}
                </label>
                <InputGroup
                  type="text"
                  placeholder={I18n.t("new_circle.placeholders.product_name_suggestion")}
                  fill={true}
                  id="name"
                  className="no-icon"
                  value={this.state.circle_form.name}
                  onChange={this.updateFields}
                />
              </div>

              <div className={this.state.validation_errors.price ? "form-group error" : "form-group"}>
                <label htmlFor="price">
                  {this.state.validation_errors.price ? (
                    <Translate value={this.state.validation_errors.price[0]} />
                  ) : (
                    <Translate value="new_circle.labels.product_price" />
                  )}
                </label>
                <InputGroup
                  type="number"
                  placeholder={I18n.t("new_circle.placeholders.add_price")}
                  fill={false}
                  id="price"
                  className="no-icon has-button"
                  rightElement={
                    <CurrencySelect
                      current_currency={this.state.circle_form.currency ? this.state.circle_form.currency : "SEK"}
                      currencyChanged={(currency) => {
                        this.updateFields({
                          target: { id: "currency", value: currency },
                        });
                      }}
                    />
                  }
                  value={this.state.circle_form.price}
                  onChange={this.updateFields}
                />
              </div>

              <div className={this.state.validation_errors.url ? "form-group error" : "form-group"}>
                <label htmlFor="url">
                  {this.state.validation_errors.url ? (
                    <Translate value={this.state.validation_errors.url[0]} />
                  ) : (
                    <Translate value="new_circle.labels.product_url" />
                  )}
                </label>
                <InputGroup
                  type="url"
                  placeholder={I18n.t("new_circle.placeholders.url_suggestion")}
                  fill={false}
                  id="url"
                  className="no-icon"
                  value={this.state.circle_form.url}
                  onChange={this.updateFields}
                />
              </div>
              <div
                className={this.state.validation_errors.address ? "form-group error" : "form-group"}
                onClick={this.showLocationModal}>
                <label htmlFor="address">
                  {this.state.validation_errors.address ? (
                    <Translate value={this.state.validation_errors.address[0]} />
                  ) : (
                    <Translate value={"user_details.labels.location"} />
                  )}
                </label>
                <InputGroup
                  readOnly={true}
                  type="text"
                  disabled={false}
                  placeholder={I18n.t("user_details.placeholders.location")}
                  fill={true}
                  id="address"
                  value={this.state.circle_form.address}
                  className="no-icon has-button circle-form-address"
                  rightElement={
                    this.state.show_location_loader ? (
                      <LoadingIndicator />
                    ) : (
                      <Button className="input-button right">
                        <Icon icon="locate" iconSize="20" className="icon" />
                      </Button>
                    )
                  }
                />
              </div>
            </div>
          </div>
          <div className={this.state.validation_errors.description ? "form-group error" : "form-group"}>
            <label htmlFor="description">
              {this.state.validation_errors.description ? (
                <Translate value={this.state.validation_errors.description[0]} />
              ) : (
                <Translate value="new_circle.labels.description" />
              )}
            </label>
            <TextArea
              placeholder={I18n.t("new_circle.placeholders.description_placeholder")}
              fill={true}
              id="description"
              value={this.state.circle_form.description}
              onChange={this.updateFields}
            />
          </div>
          <div className="form-group">
            <Switch
              id="is_public"
              label={I18n.t("new_circle.public_circle_switch")}
              checked={this.state.circle_form.is_public}
              onChange={(event) => {
                this.updateFields({ target: { id: "is_public", value: event.target.checked } });
              }}
              large={true}
            />
            <Callout intent="default" title={I18n.t("new_circle.public_circle_title")}>
              <Translate value="new_circle.public_circle_explain" />
            </Callout>
          </div>
          {this.props.is_super_user && (
            <>
              <div className="form-group">
                <label htmlFor="door_id">
                  <Translate value="new_circle.labels.door_id" />
                </label>
                <InputGroup
                  type="number"
                  placeholder={I18n.t("new_circle.placeholders.door_id")}
                  fill={false}
                  id="door_id"
                  className="no-icon"
                  value={this.state.circle_form.door_id}
                  onChange={this.updateFields}
                />
              </div>
              <div className="form-group">
                <label htmlFor="door_indications_heading">
                  <Translate value="new_circle.labels.door_indications_heading" />
                </label>
                <InputGroup
                  type="text"
                  placeholder={I18n.t("new_circle.placeholders.door_indications_heading")}
                  fill={false}
                  id="door_indications_heading"
                  className="no-icon"
                  value={this.state.circle_form.door_indications_heading}
                  onChange={this.updateFields}
                />
              </div>
              <div className="form-group">
                <label htmlFor="door_indications_paragraph_1">
                  <Translate value="new_circle.labels.door_indications_paragraph_1" />
                </label>
                <InputGroup
                  type="text"
                  placeholder={I18n.t("new_circle.placeholders.door_indications_paragraph_1")}
                  fill={false}
                  id="door_indications_paragraph_1"
                  className="no-icon"
                  value={this.state.circle_form.door_indications_paragraph_1}
                  onChange={this.updateFields}
                />
              </div>
              <div className="form-group">
                <label htmlFor="door_indications">
                  <Translate value="new_circle.labels.door_indications" />
                </label>
                <InputGroup
                  type="text"
                  placeholder={I18n.t("new_circle.placeholders.door_indications")}
                  fill={false}
                  id="door_indications"
                  className="no-icon"
                  value={this.state.circle_form.door_indications}
                  onChange={this.updateFields}
                />
              </div>
              <div className="form-group">
                <label htmlFor="door_indications_paragraph_2">
                  <Translate value="new_circle.labels.door_indications_paragraph_2" />
                </label>
                <InputGroup
                  type="text"
                  placeholder={I18n.t("new_circle.placeholders.door_indications_paragraph_2")}
                  fill={false}
                  id="door_indications_paragraph_2"
                  className="no-icon"
                  value={this.state.circle_form.door_indications_paragraph_2}
                  onChange={this.updateFields}
                />
              </div>
              <div className="form-group">
                <label htmlFor="door_indications_image_url">
                  <Translate value="new_circle.labels.door_indications_image_url" />
                </label>
                <InputGroup
                  type="text"
                  placeholder={I18n.t("new_circle.placeholders.door_indications_image_url")}
                  fill={false}
                  id="door_indications_image_url"
                  className="no-icon"
                  value={this.state.circle_form.door_indications_image_url}
                  onChange={this.updateFields}
                />
              </div>
              <div className={this.state.validation_errors.instructions ? "form-group error" : "form-group"}>
                <label htmlFor="instructions">
                  {this.state.validation_errors.instructions ? (
                    <Translate value={this.state.validation_errors.instructions[0]} />
                  ) : (
                    "Instructions"
                  )}
                </label>
                <ReactQuill
                  id="instructions"
                  theme="snow"
                  modules={this.state.quillModules}
                  formats={this.state.quillFormats}
                  value={this.state.circle_form.instructions}
                  onChange={this.updateInstructions}
                />
              </div>
              <div className="form-group">
                <Switch
                  id="is_prylpoolen"
                  label={I18n.t("new_circle.is_prylpoolen_switch")}
                  checked={this.state.circle_form.is_prylpoolen}
                  onChange={(event) => {
                    this.updateFields({ target: { id: "is_prylpoolen", value: event.target.checked } });
                  }}
                  large={true}
                />
                <Callout intent="default" title={I18n.t("new_circle.is_prylpoolen_title")}>
                  <Translate value="new_circle.is_prylpoolen_explain" />
                </Callout>
              </div>
              <div className="form-group">
                <Switch
                  id="rentable"
                  label={I18n.t("new_circle.labels.rentable_switch")}
                  checked={this.state.circle_form.rentable}
                  onChange={(event) => {
                    this.updateFields({ target: { id: "rentable", value: event.target.checked } });
                  }}
                  large={true}
                />
              </div>
              <div className="form-group">
                <label htmlFor="rental_pricing_tier">
                  <Translate value="new_circle.labels.rental_pricing_tier" />
                </label>
                <InputGroup
                  type="text"
                  placeholder={I18n.t("new_circle.placeholders.rental_pricing_tier")}
                  fill={false}
                  id="rental_pricing_tier"
                  className="no-icon"
                  value={this.state.circle_form.rental_pricing_tier}
                  onChange={this.updateFields}
                />
              </div>
              <div className="super-user-select">
                <label className="booking-limitation-title">
                  <Translate value="new_circle.booking_limitations_title" />
                </label>
                <Callout intent="default" className="booking-limitation-callout">
                  <Translate value="new_circle.booking_limitations_explain" />
                  <div className="form-group">
                    <label htmlFor="max_active_bookings">
                      <Translate value="new_circle.labels.max_active_bookings" />
                    </label>
                    <MaxActiveBookings
                      current_value={
                        this.state.circle_form.max_active_bookings_per_member
                          ? this.state.circle_form.max_active_bookings_per_member
                          : -1
                      }
                      onValueChange={(max_bookings) => {
                        this.updateFields({
                          target: { id: "max_active_bookings_per_member", value: max_bookings },
                        });
                      }}
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="max_booking_duration">
                      <Translate value="new_circle.labels.max_booking_duration" />
                    </label>
                    <MaxBookingDuration
                      current_value={
                        this.state.circle_form.max_booking_duration_in_minutes
                          ? this.state.circle_form.max_booking_duration_in_minutes
                          : -1
                      }
                      onValueChange={(max_duration) => {
                        this.updateFields({
                          target: { id: "max_booking_duration_in_minutes", value: max_duration },
                        });
                      }}
                    />
                  </div>
                </Callout>
              </div>
            </>
          )}
          {this.props.show_agreement_switch && (
            <>
              <div className="form-group">
                <Switch
                  id="pre_owned"
                  label={I18n.t("new_circle.pre_owned_switch")}
                  checked={this.state.circle_form.pre_owned}
                  onChange={(event) => {
                    this.updateFields({ target: { id: "pre_owned", value: event.target.checked } });
                  }}
                  large={true}
                />
                <Callout intent="default" title={I18n.t("new_circle.pre_owned_title")}>
                  <Translate value="new_circle.pre_owned_explain" />
                </Callout>
              </div>
              <div className="form-group">
                <Switch
                  id="has_agreement"
                  label={I18n.t("new_circle.agreement_switch")}
                  checked={this.state.circle_form.has_agreement}
                  onChange={(event) => {
                    this.updateFields({ target: { id: "has_agreement", value: event.target.checked } });
                  }}
                  large={true}
                />
                <Callout intent="default" title={I18n.t("new_circle.agreement_title")}>
                  <Translate value="new_circle.agreement_explain" />
                  <a href=" " onClick={this.toggleAgreement}>
                    <Translate value="new_circle.preview_agreement_button" />
                  </a>
                </Callout>
              </div>
            </>
          )}
          <div className="form-group">
            <label>
              <Translate value="new_circle.labels.number_of_owners" />
            </label>
            <Slider
              min={2}
              max={this.state.circle_form.is_prylpoolen ? 100 : 10}
              stepSize={1}
              labelStepSize={this.state.circle_form.is_prylpoolen ? 5 : 1}
              labelRenderer={true}
              value={this.state.circle_form.max_owners_no ? parseInt(this.state.circle_form.max_owners_no) : 2}
              showTrackFill={true}
              onChange={(number) => {
                this.updateFields({ target: { id: "max_owners_no", value: number } });
              }}
            />
          </div>
          {!this.props.isSaving && (
            <Button type="submit" intent="primary" className="cta" fill={true}>
              {this.props.edit_circle && !("new_circle" in this.props.edit_circle) ? (
                <Translate value="new_circle.edit_circle_button" />
              ) : (
                <Translate value="new_circle.create_circle_button" />
              )}
            </Button>
          )}
          {this.props.isSaving && <LoadingIndicator />}
        </form>
        <AgreementModal show_modal={this.state.show_agreement} closeModal={this.toggleAgreement} />
      </>
    );
  }
}

export default CircleForm;
